import { Link } from 'react-router-dom';
import HPlogo from '../../../assets/HPlogo.png';

export default function LogoSection() {
  return (
    <Link
      to="/"
      className="flex items-center group relative select-none lg:mx-2"
      aria-label="Handpreneur Home"
    >
      <img 
        src={HPlogo} 
        alt="Handpreneur" 
        className="h-10 sm:h-11 lg:h-12 w-auto object-contain transition-transform duration-300 group-hover:scale-105"
      />
    </Link>
  );
}
